import React, { ReactNode } from 'react';
import cartoucheHomme from '../../../../img/cartouche_homme.png';
import { MemberDTO } from '../../../../network/api/types/compte/MemberDTO';
import cartouchFemme from '../../../../img/cartouche_femme.png';

type Props = {
  member: MemberDTO,
};

class GestionnaireTile extends React.PureComponent<Props> {
  getAvatar = (personne?: MemberDTO): JSX.Element => {
    if (personne && personne.profilePicture) {
      return (<img alt="Profile pic" src={personne.profilePicture} />);
    }
    return (<img alt="Profile pic" src={this.props.member.civilite === 'Madame' ? cartouchFemme : cartoucheHomme} />);
  };

  render(): ReactNode {
    return (
      <div className="rattachement-tile">
        <div className="rattachement-tile-header">
          <div className="picture">
            {this.getAvatar(this.props.member)}
          </div>
          <div>
            <div className="personne-name">
              {this.props.member.nomDaffichage}
            </div>
            <div className="caption personne-role">
              {this.props.member.fonction}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GestionnaireTile;
